import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import MaxCombinationsPercentValidator from 'components/organisms/singlegame-forced-stacking/validators/max-combinations-percent-validator';
import AtLeastOneCombinationWasChosenValidator from 'components/organisms/singlegame-forced-stacking/validators/at-least-one-combination-was-chosen-validator';
import BaseValidator from 'services/validations/base-validator';

class ForcedStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        if (!stacking.isEnabled()) {
            return validator;
        }

        const maxCombinationsPercentValidator = new MaxCombinationsPercentValidator();
        maxCombinationsPercentValidator.setDependencies({stacking});

        const atLeastOneCombinationWasChosenValidator = new AtLeastOneCombinationWasChosenValidator();
        atLeastOneCombinationWasChosenValidator.setDependencies({stacking});

        validator.addSubValidators([maxCombinationsPercentValidator, atLeastOneCombinationWasChosenValidator]);

        return validator;
    }
}

export {ForcedStackingValidatorBuilder};
